import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
import { activeUserSelector } from './user';
export const tasksReducer = (state) => state.reduxTasks;
export const tasksSelector = createSelector(tasksReducer, (selector) => selector);
export const tasksDataSelector = createSelector(tasksReducer, (selector) => selector.data);
export const allTasksDataSelector = createSelector(tasksReducer, (selector) => selector.allTasks);
export const reduxActivitiesSelector = (state) => state.reduxActivities;
export const allActivitiesSelector = createSelector(reduxActivitiesSelector, (selector) => selector.allActivities.data);
export const allActivitiesWithTasksRelationsSelector = createSelector([allActivitiesSelector, allTasksDataSelector], (activities, tasks) => {
    const allActivitiesWithTasksRelation = activities.map((activity) => {
        var _a;
        const relatedTaskInst = (_a = tasks.find((task) => task.id === activity.task)) !== null && _a !== void 0 ? _a : activity.taskInst;
        return Object.assign(Object.assign({}, activity), { taskInst: relatedTaskInst, taskType: (activity === null || activity === void 0 ? void 0 : activity.taskType) || (relatedTaskInst === null || relatedTaskInst === void 0 ? void 0 : relatedTaskInst.taskType) });
    });
    return allActivitiesWithTasksRelation;
});
export const myActivitiesSelector = createSelector([allActivitiesSelector, activeUserSelector], (activities, activeUser) => {
    return activities.filter((activity) => activity.user === activeUser);
});
export const myTodayActivitiesSelector = createSelector([allActivitiesSelector, activeUserSelector], (activities, activeUser) => {
    const todayDate = moment().format('YYYY-MM-DD');
    return activities.filter((activity) => activity.user === activeUser && activity.date === todayDate);
});
export const myActivitiesWithRelationsSelector = createSelector([myActivitiesSelector, allTasksDataSelector], (activities, tasks) => {
    const myActivitiesWithTasksRelation = activities.map((activity) => {
        var _a;
        const relatedTaskInst = (_a = tasks.find((task) => task.id === activity.task)) !== null && _a !== void 0 ? _a : activity.taskInst;
        return Object.assign(Object.assign({}, activity), { taskInst: relatedTaskInst });
    });
    return myActivitiesWithTasksRelation;
});
export const myActivitiesByDateRangeWithTypeSelector = (startDate, endDate) => createSelector(myActivitiesWithRelationsSelector, (activities) => {
    return activities.filter((activity) => activity.activityType && moment(activity.date).isBetween(startDate, endDate, 'day', '[]'));
});
export const myTodayActivitiesWithRelationsSelector = createSelector([myTodayActivitiesSelector, allTasksDataSelector], (activities, tasks) => {
    const myActivitiesWithTasksRelation = activities.map((activity) => {
        var _a;
        const relatedTaskInst = (_a = tasks.find((task) => task.id === activity.task)) !== null && _a !== void 0 ? _a : activity.taskInst;
        return Object.assign(Object.assign({}, activity), { taskInst: relatedTaskInst });
    });
    return myActivitiesWithTasksRelation;
});
export const userActivitiesByTaskSelector = (userId, tasks) => createSelector(allActivitiesWithTasksRelationsSelector, (activities) => {
    return activities.filter((activity) => {
        return activity.user === userId && tasks.includes(activity.task);
    });
});
export const userActivitiesByDateSelector = (userId, date) => createSelector(allActivitiesWithTasksRelationsSelector, (activities) => {
    return activities.filter((activity) => activity.user === userId && activity.date === moment(date).format('YYYY-MM-DD'));
});
